// const serverURL = "https://api-fleet-management.1now.app";
let serverURL: string;

if (process.env.REACT_APP_ENV === "dev") {
  serverURL = "https://fleet-management-dev.1now.app";
} else if (process.env.REACT_APP_ENV === "stage") {
  serverURL = "https://api-stage.1now.app";
} else {
  serverURL = "https://api-fleet-management.1now.app";
}

export default serverURL;
//  export const serverURL = 'http://192.168.100.222:8000';
